import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    GroupPerson,
    GroupSection,
    ManagedGroup,
} from "../models/group.models";

export const GroupsActions = createActionGroup({
    source: "Groups",
    events: {
        "Page Opened": emptyProps(),
        "Groups Loaded": props<{ groups: ManagedGroup[] }>(),
        "Groups Load Failed": emptyProps(),
        "Group Selected": props<{ groupId: string }>(),
        "People Loaded": props<{
            groupId: string;
            members: GroupPerson[];
            admins: GroupPerson[];
        }>(),
        "People Load Failed": props<{ groupId: string }>(),
        "Group Query Changed": props<{ query: string }>(),
        "People Query Changed": props<{ query: string }>(),
        "Section Changed": props<{ section: GroupSection }>(),
        "Create Requested": props<{ name: string }>(),
        "Create Succeeded": props<{ group: ManagedGroup }>(),
        "Rename Requested": props<{ group: ManagedGroup; name: string }>(),
        "Rename Succeeded": props<{ group: ManagedGroup }>(),
        "Delete Requested": props<{ groupId: string }>(),
        "Delete Succeeded": props<{ groupId: string }>(),
        "Add Members Requested": props<{
            groupId: string;
            usernames: string[];
        }>(),
        "Remove Members Requested": props<{
            groupId: string;
            usernames: string[];
        }>(),
        "Add Admins Requested": props<{
            groupId: string;
            userIds: string[];
        }>(),
        "Remove Admins Requested": props<{
            groupId: string;
            usernames: string[];
        }>(),
        "People Mutation Succeeded": props<{ groupId: string }>(),
        "Mutation Failed": emptyProps(),
        "Mutation Status Cleared": emptyProps(),
    },
});
